'use strict';

module.exports = require('./lib/AsyncEventEmitter');



//////////////////
// WEBPACK FOOTER
// ./~/async-eventemitter/index.js
// module id = 1025
// module chunks = 0 1 2